module.exports = __webpack_public_path__ + "static/media/hero-banner-sm.1a06787c.png";